import axios from "axios";
import API_URL from "../config/config";

export const CONTACT_FORM_INITIAL_STATE = {
  name: "",
  email: "",
  mobile: "",
  message: "",
};

const CONTACT_SOURCE_LABELS = {
  home: "Home Page",
  contact: "Contact Page",
};

export const formatContactSourceLabel = (source) =>
  CONTACT_SOURCE_LABELS[source] || "Website";

export const submitContactForm = async (formData, source) => {
  const payload = {
    name: String(formData?.name || "").trim(),
    email: String(formData?.email || "").trim(),
    mobile: String(formData?.mobile || "").replace(/\D/g, ""),
    message: String(formData?.message || "").trim(),
    source: source === "home" ? "home" : "contact",
  };

  return axios.post(`${API_URL}/contact`, payload);
};
